/* BundleStrip.jsx, renders two related RecommendationStrips side-by-
   side with a single shared headline. Used on estate / suburb / H&L
   pages where the user is about to commit to land + a builder, so we
   surface BOTH categories together at the right moment.

   On mobile the two strips stack vertically; on desktop they sit
   side-by-side in a 2-col grid.

   Phase 1.5 (2026-06-01).
*/
import React from 'react';
import RecommendationStrip from './RecommendationStrip';

export default function BundleStrip({
  eyebrow,
  headline,
  body,
  state,
  sourcePage,
  strips = [],   // [{ category, sourcePlacement, eyebrow, headline, body, ctaLabel }]
}) {
  if (!strips.length) return null;
  return (
    <section className="bp-rec-bundle" data-testid="rec-bundle">
      {(headline || body) && (
        <header className="bp-rec-bundle-head">
          {headline && <h3 className="bp-rec-bundle-headline">{headline}</h3>}
          {body && <p className="bp-rec-bundle-body">{body}</p>}
        </header>
      )}
      <div className="bp-rec-bundle-grid">
        {strips.map((s) => (
          <RecommendationStrip
            key={s.category + ':' + s.sourcePlacement}
            category={s.category}
            sourcePlacement={s.sourcePlacement}
            sourcePage={sourcePage}
            state={state}
            eyebrow={s.eyebrow}
            headline={s.headline}
            body={s.body}
            ctaLabel={s.ctaLabel}
            linkTo={s.linkTo || null}
          />
        ))}
      </div>
    </section>
  );
}
